export enum LoginOption {
  technician = 'technician',
  customer = 'customer',
  manager = 'manager',
  requester = 'requester',
  vendor = 'vendor',
  default = 'default - Not logged-in',
}
